import axios from 'axios';
import { Todo, TodosResponse, TodoStats } from '../types/todo';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

class TodoService {
  async getTodos(params?: {
    completed?: boolean;
    category?: string;
    priority?: string;
    page?: number;
    limit?: number;
  }): Promise<TodosResponse> {
    const response = await axios.get<TodosResponse>(`${API_BASE_URL}/todos`, { params });
    return response.data;
  }

  async getTodo(id: string): Promise<Todo> {
    const response = await axios.get<Todo>(`${API_BASE_URL}/todos/${id}`);
    return response.data;
  }

  async createTodo(data: {
    title: string;
    description: string;
    category?: string;
    priority?: string;
    tags?: string[];
  }): Promise<Todo> {
    const response = await axios.post<Todo>(`${API_BASE_URL}/todos`, data);
    return response.data;
  }

  async updateTodo(
    id: string,
    data: Partial<Pick<Todo, 'title' | 'description' | 'category' | 'priority' | 'tags' | 'dates' | 'order'>>
  ): Promise<Todo> {
    const response = await axios.patch<Todo>(`${API_BASE_URL}/todos/${id}`, data);
    return response.data;
  }

  async toggleTodo(id: string): Promise<Todo> {
    console.log('TodoService: Making toggle request to:', `${API_BASE_URL}/todos/${id}/toggle`);
    console.log('TodoService: Auth header:', axios.defaults.headers.common['Authorization']);
    try {
      const response = await axios.patch<Todo>(`${API_BASE_URL}/todos/${id}/toggle`);
      console.log('TodoService: Toggle response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('TodoService: Toggle error:', error);
      console.error('TodoService: Error response:', error.response);
      throw error;
    }
  }

  async deleteTodo(id: string): Promise<void> {
    await axios.delete(`${API_BASE_URL}/todos/${id}`);
  }

  async getStats(): Promise<TodoStats> {
    const response = await axios.get<TodoStats>(`${API_BASE_URL}/todos/stats`);
    return response.data;
  }

  async reorderTodos(todoIds: string[]): Promise<Todo[]> {
    const response = await axios.patch<Todo[]>(`${API_BASE_URL}/todos/reorder`, { todoIds });
    return response.data;
  }

  async bulkUpdateTodos(todoIds: string[], updates: Partial<Pick<Todo, 'category' | 'priority' | 'tags'>>): Promise<{ updated: number; todos: Todo[] }> {
    const response = await axios.patch<{ updated: number; todos: Todo[] }>(`${API_BASE_URL}/todos/bulk/update`, { 
      todoIds, 
      updates 
    });
    return response.data;
  }
}

export const todoService = new TodoService();